/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enum for different type of filtering options we offer in exports
 */
export enum ApiExportFilterOptionType {
    /**
     * Filter option for date range
     */
    Range = 0,
}
